import api from "../Utils/Interceptor";

// New user-management auth (mounted under /api/v1).
export const loginRequest = (email, password) => api.post("/api/v1/auth/login", { email, password });

// Called during the forced temp-password flow. The Authorization header must carry the
// 3-minute temp token — store it in sessionStorage("token") before calling so the request
// interceptor sends it.
export const changeTempPasswordRequest = (password, confirm_password) =>
  api.put("/api/v1/user/change/temp-password", { password, confirm_password });

// Caller's permission on the 'kirtan' module (defaults to all-'none' server-side if absent).
export const fetchKirtanPermission = () => api.get("/api/v1/permission/module/kirtan");

export const logoutRequest = () => api.post("/api/v1/auth/logout");
